import { render, staticRenderFns } from "./StaffUserManager.vue?vue&type=template&id=443fc630&"
import script from "./StaffUserManager.vue?vue&type=script&lang=ts&"
export * from "./StaffUserManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports